var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0278 0.353066L10.8623 0.0929105C9.71651 0.08269 8.77069 1.01179 8.76047 2.15758C8.75025 3.30337 9.67935 4.24919 10.8251 4.25941L39.9906 4.51957C41.1364 4.52979 42.0823 3.60069 42.0925 2.4549C42.1027 1.30911 41.1736 0.363287 40.0278 0.353066ZM10.4163 50.0909L39.5818 50.3511C40.7276 50.3613 41.6734 49.4322 41.6837 48.2864C41.6939 47.1406 40.7648 46.1948 39.619 46.1846L10.4535 45.9244C9.3077 45.9142 8.36187 46.8433 8.35165 47.9891C8.34143 49.1349 9.27053 50.0807 10.4163 50.0909ZM42.0367 8.70465L8.70472 8.40733C6.41314 8.38689 4.52149 10.2451 4.50105 12.5367L4.27806 37.5357C4.25762 39.8272 6.11582 41.7189 8.4074 41.7393L41.7394 42.0367C44.031 42.0571 45.9226 40.1989 45.9431 37.9073L46.1661 12.9083C46.1865 10.6167 44.3283 8.72509 42.0367 8.70465ZM25.3196 14.2849C27.9029 14.308 29.9882 16.4308 29.9651 19.0141C29.9421 21.5973 27.8192 23.6826 25.236 23.6596C22.6528 23.6365 20.5675 21.5137 20.5905 18.9304C20.6135 16.3472 22.7364 14.2619 25.3196 14.2849ZM35.5454 35.7312L14.7129 35.5453L14.7408 32.4205C14.7718 28.9414 21.7245 27.2742 25.2035 27.3052C28.6825 27.3363 35.6043 29.1273 35.5733 32.6063L35.5454 35.7312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.446045) rotate(0.511064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.621f89d53823d036c35528cfd7895766.svg";
export { ForwardRef as ReactComponent };